<template>
  <button>
    <span class="label">analyse</span>

    <svg
      :class="[{ open: open }, analyseStatus]"
      class="triangle"
      xmlns="http://www.w3.org/2000/svg"
      width="7"
      height="9"
      viewBox="0 0 7 9"
    >
      <path
        fill="#1CD55D"
        fill-rule="evenodd"
        d="M53.350798,8.37748247 L55.8813132,12.4745071 C56.1715349,12.9443899 56.0258909,13.5605763 55.5560081,13.850798 C55.3980857,13.9483383 55.216132,14 55.0305152,14 L49.9694848,14 C49.4172,14 48.9694848,13.5522847 48.9694848,13 C48.9694848,12.8143832 49.0211465,12.6324295 49.1186868,12.4745071 L51.649202,8.37748247 C51.9394237,7.90759971 52.5556101,7.76195565 53.0254929,8.05217736 C53.1577361,8.13385698 53.2691184,8.24523927 53.350798,8.37748247 Z"
        transform="rotate(-90 25 32)"
      />
    </svg>
  </button>
</template>

<script>
export default {
  props: ['open', 'status'],
  computed: {
    analyseStatus() {
      if (
        this.status === 'READY_NOT_ANALYZED' ||
        this.status === 'READY_PASSWORD_PROTECTED'
      ) {
        return 'fail'
      } else if (this.status === 'READY') {
        return 'ready'
      } else {
        return 'analyzing'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.label {
  font-size: 0.82rem;
  font-style: italic;
  font-weight: 500;
  padding-right: 3px;
}

.triangle {
  transform-origin: 5px 4px;
  transition: transform 0.25s;

  &.open {
    transform: rotate(-90deg);
  }
}

.ready {
  path {
    fill: #1cd55d;
  }
}

.fail {
  path {
    fill: #ff8f00;
  }
}

.analyzing {
  path {
    fill: #4f4f4f;
  }
}
</style>
